
import {of as observableOf,  Observable, Subscription } from 'rxjs';
import { AfterViewInit, Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, NgForm, Validators } from '@angular/forms';
import { DemographicsService } from './demographics.service';
import { AuthService } from '../../../../core/auth.service';
import { BaseService } from '../../../../shared/base.service';
import { ClinicsService } from '../../../../clinics/clinics.service';
import { BaseComponent } from '../../../../shared/base.component';
import { AppService } from '../../../../app.service';
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { UsersService } from '../../../../users/users.service';
import { HomeService } from '../../../../home/home.service';
import { MaintenanceService } from '../../../../maintenance/maintenance.service';
import { SecureApi } from '../../../../core/secure.api';
import {CoreService} from "../../../../core/core.service";
import * as moment from 'moment';
import { InsurancePartnerComponent } from '../../insurance-partner.component';

@Component({
    selector: 'demographics-component',
    templateUrl: './demographics.component.html',
    styleUrls: ['./demographics.component.scss'],
    providers: [DemographicsService, ClinicsService, BaseService]
})

export class DemographicsComponent extends InsurancePartnerComponent implements OnInit, AfterViewInit {
    helpClinicProfile: any;
    @Input() isHome = false;
    @Input() filters;
    @Input() url = '/admin/mental';
    roles: Object[] = [];
    clinicUsers: Object[] = [];
    clinicId: any = '';
    isFocusMobileInput: boolean = false;
    userRoleId: number;
    isEditable: boolean = false;
    subAdminRight: Subscription;
    clinic: Object = null;
    clinicName: string;
    data: any;
    message: string;
    filterAge: any;
    gendersData = [];
    agesData = [];
    languagesData = [];
    @ViewChild('formDirective') private formDirective: NgForm;

    constructor(public authService: AuthService,
                public coreService: CoreService,
                public router: Router,
                public translate: TranslateService,
                public fb: FormBuilder,
                public baseService: BaseService,
                public appService: AppService,
                public usersService: UsersService,
                public homeService: HomeService,
                public clinicService: ClinicsService,
                public secureApi: SecureApi,
                public route: ActivatedRoute,
                public service: DemographicsService) {
        super(authService, router, translate, baseService, appService, usersService, homeService);
    }

    ngOnInit() {
        this.userRoleId = this.authService.user['role_id'];

        // process url query parameters e.g.
        this.route.queryParams.subscribe(params => {
        });
    }

    /**
     * preload mobile number for mobile field
     * @param {SimpleChanges} changes
     */
    ngOnChanges(changes: SimpleChanges) {
        if (changes['filters'] && this.filters) {
            return this.getItems();
        }
    }

    ngAfterViewInit() {
    }

    get isClinicView() {
        return this.clinicId;
    }

    get isAdminView() {
        return (this.clinicName == null && this.clinicCity == null);
    }

    getItems() {
        this.data = null;
        this.message = 'Fetching data...';
        this.service.getAll(this.filters).subscribe(response => {
            this.isLoading = false;
            this.message = response['message'] || '';
            return this.setData(response);
        });
    }

    setData(data: any): void {
        this.gendersData = data['genders'] || [];
        this.agesData = data['ages'] || [];
        this.languagesData = data['languages'] || [];
        this.data = data && (data['genders'] || data['ages'] || data['languages']) ? data : null;
    }

    setFilterAge(){
        if(!this.filterAge){
            return;
        }
        this.filters.startAge = this.filterAge[1] || 0;
        this.filters.endAge = this.filterAge[2] || 0;
        this.setFilters();
        return this.getItems();
    }

    navigateRoute() {
        this.router.navigate(['./'], {
            relativeTo: this.route
        });
    }

    sortUsers(column) {
        if (column === 'created_at') {
            column = 'created_at_sort';
        }

        this.sort(column, false);
    }

    isB2CAdminRole(){
        return this.roleId === this.authService.ROLES.B2C_ADMIN;
    }

    activate(item){
    }

    getPercentage(data){
        return 100 - parseFloat(data['low']) - parseFloat(data['medium']);
    }
}
